import { render, staticRenderFns } from "./ChannelDistributionCommonPage.vue?vue&type=template&id=56e8930c&scoped=true&"
import script from "./ChannelDistributionCommonPage.vue?vue&type=script&lang=ts&"
export * from "./ChannelDistributionCommonPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelDistributionCommonPage.vue?vue&type=style&index=0&id=56e8930c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e8930c",
  null
  
)

export default component.exports